import { balanceReminderMessage } from "./payment-terms.js";
/** Google review link shared by Ruta Mágica. */
export const REVIEW_URL = "https://share.google/kdt4HI2oIHrMVfOGN";
const services = { tour: "tour", school: "visita escolar", balloon: "vuelo en globo" };
const ddmm = (date) => date.slice(0, 10).split("-").reverse().join("/");
const MONTHS = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const monthName = (date) => MONTHS[Number(date.slice(5, 7)) - 1] ?? "";
// Schools are greeted by their full name ("Escuela América Nueva"); people by their first name.
const hello = (name, service = "") => {
    const first = service === "school" ? name.trim() : name.trim().split(/\s+/)[0] ?? "";
    return `Hola${first ? ` ${first}` : ""}`;
};
/** Tasks in "Hoy" that come with a message for the customer. */
export const MESSAGE_TASKS = ["balance_due", "issued_proposal_without_response", "proposal_without_response", "school_visit_details", "review_request", "confirm_exact_date"];
/** The WhatsApp text for a task, or null when the task has no customer message. */
export function automationMessage(ruleKey, facts) {
    const service = services[facts.service] ?? "servicio";
    const reviewUrl = facts.reviewUrl === undefined ? REVIEW_URL : facts.reviewUrl;
    const when = facts.serviceDate ? ` del ${ddmm(facts.serviceDate)}` : "";
    switch (ruleKey) {
        case "balance_due":
            return balanceReminderMessage({
                customerName: facts.customerName,
                service: facts.service,
                amount: facts.balance ?? 0,
                currency: facts.currency ?? "MXN",
                serviceDate: facts.serviceDate ?? null,
                dueDate: facts.dueDate ?? null,
            });
        case "issued_proposal_without_response":
        case "proposal_without_response":
            return `${hello(facts.customerName, facts.service)}, ¿pudiste revisar la cotización de tu ${service}${when}? Si tienes alguna duda o quieres ajustar fecha, horario o número de personas, con gusto te ayudo. Te recuerdo que los lugares se apartan conforme se confirman.`;
        case "school_visit_details":
            return `${hello(facts.customerName, facts.service)}, ya casi es la visita escolar${when}. Para tener todo listo, ¿nos confirmas por favor?\n1. Número final de alumnos y docentes.\n2. Menú elegido para el grupo.\n3. Hora aproximada de llegada del autobús.\n¡Gracias!`;
        case "review_request":
            return `${hello(facts.customerName, facts.service)}, gracias por visitarnos en tu ${service}${when}. Esperamos que lo hayan disfrutado mucho. ¿Nos ayudarías con una reseña? Nos ayuda muchísimo a seguir creciendo${reviewUrl ? `: ${reviewUrl}` : "."} ¡Gracias!`;
        case "confirm_exact_date": {
            const month = facts.serviceDate ? ` en ${monthName(facts.serviceDate)}` : "";
            return `${hello(facts.customerName, facts.service)}, ¿ya tienen el día exacto para su ${service}${month}? Con eso apartamos la fecha y te confirmo disponibilidad.`;
        }
        default:
            return null;
    }
}
